import { post } from "@readai/common/api";
import type {
  ApiEnterpriseSearchResponse,
  EnterpriseSearchQueryRequest,
  EnterpriseSearchResponse,
} from "@readai/common/types/enterpriseSearchTypes";

import { REQUEST_ID_HEADER_KEY } from "../constants/enterpriseSearch";
import * as EnterpriseSearchParser from "./parsers/enterpriseSearch";

export const search = async (
  request: EnterpriseSearchQueryRequest,
): Promise<EnterpriseSearchResponse> => {
  const body = EnterpriseSearchParser.transformRequest(request);
  const resp = await post("/discovery/v0/enterprise/search", body, {
    withCreds: true,
    returnResponseHeaders: [REQUEST_ID_HEADER_KEY],
  });
  const response = resp as ApiEnterpriseSearchResponse;
  return EnterpriseSearchParser.parseResponse(response);
};
